import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus, { ElMessage } from 'element-plus';
import 'element-plus/dist/index.css';
import { Tree } from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import { createPinia } from 'pinia';
import { newRouter } from '@/router';
import initRouter from '@/router/hook';
import request from '@/lib/request';
import errReport from '@/lib/errReport';
import 'core-js/actual/array/flat-map';
import { bigDataInit } from '@/lib/bigDataTrack';

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(Tree);
app.config.globalProperties.$http = request;
app.config.globalProperties.$message = ElMessage;
app.config.errorHandler = (err, vm) => {
  let { message, name, stack } = err;
  if (message || name) {
    errReport(`组件：${vm?.$options?.__name}`, stack ? stack.toString() : `${name}:${message}`);
  }
  console.error(err);
};

const isLocal = /localhost|127\.0.0.1/i.test(location.hostname);
isLocal &&
  localStorage.setItem(
    'LINGHIT_UNIFY_BACKEND_TOKEN_V2',
    JSON.stringify({
      value: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVSUQiOjE1NzMyOTIxNDcwMDAwMDA1MCwiU2NvcGUiOiJsb2dpbiIsIkV4cGFuZCI6eyJjaGFyYWN0ZXJpc3RpYyI6IjNlMzJlNGNkODk5YTk3OTBjNGUxMjUyNTFiNzRjNjJlIiwiaXAiOjI4ODY3NTgwNzV9LCJleHAiOjE3MzM1NjcwODh9.ZU8xMY8H6gbBD9JGBWMP0HeH-E3B_PcufwHI8OcT9HU',
      expiry: 1733588688806,
      create: 1729822544297,
    })
  );

const router = newRouter();
initRouter(router);
app.use(router);

app.use(ElementPlus, {
  locale: zhCn,
});
bigDataInit();
app.mount('#app');

